module.exports = __webpack_public_path__ + "static/why-we-do-illustration-7768f691bb7239876d292d7e2c5934d2.svg";